import { useEffect, useState } from 'react';
import { Link as RouterLink, Navigate, Outlet, useLocation } from 'react-router-dom';

import { AppBar, Box, Button, Stack, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import VersionChip from 'components/VersionChip';
import { useAdminSession } from 'pages/admin/AdminSession';

const PAGE_TITLE = 'Plataforma efetivoWeb';

const MENU = [
    { path: '/admin', label: 'Visão geral' },
    { path: '/admin/tenants', label: 'Tenants' },
    { path: '/admin/stores', label: 'Lojas' },
    { path: '/admin/users', label: 'Usuários' }
];

/** A tela de um tenant (/admin/tenants/:id) fica no menu Tenants. */
const activeMenu = (pathname) => {
    const match = [...MENU]
        .reverse()
        .find((item) => (item.path === '/admin' ? pathname === '/admin' || pathname === '/admin/' : pathname.startsWith(item.path)));
    return match ? match.path : false;
};

const AdminLayout = () => {
    const { session, signOut } = useAdminSession();
    const { pathname } = useLocation();
    const [leaving, setLeaving] = useState(false);

    const leave = async () => {
        setLeaving(true);
        await signOut();
    };

    useEffect(() => {
        const previous = document.title;
        document.title = PAGE_TITLE;
        return () => {
            document.title = previous;
        };
    }, []);

    if (!session) return <Navigate to="/admin/login" replace />;

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
            <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Toolbar>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ flexGrow: 1 }}>
                        <Typography variant="h4" component={RouterLink} to="/admin" sx={{ color: 'primary.main', textDecoration: 'none' }}>
                            {PAGE_TITLE}
                        </Typography>
                        <VersionChip />
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Button
                            size="small"
                            color="secondary"
                            component={RouterLink}
                            to="/admin/profile"
                            startIcon={<PersonOutlineIcon />}
                            title="Meu perfil: nome, e-mail e senha"
                            sx={{ textTransform: 'none' }}
                        >
                            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                {session.user.email}
                            </Box>
                            <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                                Meu perfil
                            </Box>
                        </Button>
                        <Button size="small" color="secondary" startIcon={<LogoutOutlinedIcon />} onClick={leave} disabled={leaving}>
                            Sair
                        </Button>
                    </Stack>
                </Toolbar>
                <Tabs value={activeMenu(pathname)} variant="scrollable" scrollButtons="auto" sx={{ px: 2, minHeight: 40 }}>
                    {MENU.map((item) => (
                        <Tab
                            key={item.path}
                            value={item.path}
                            label={item.label}
                            component={RouterLink}
                            to={item.path}
                            sx={{ minHeight: 40 }}
                        />
                    ))}
                </Tabs>
            </AppBar>
            <Box component="main" sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1600, mx: 'auto' }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout;
